import React from 'react';
import './vaccinationsbar.css';
import { VaccineModel } from '../../../../../model/vaccine.model';
import { ExternalLink } from 'lucide-react';

interface VaccinationsBarProps {
    t: (key: string) => string;
    vaccinations: VaccineModel[];
    vaccinationType: string;
    className?: string;
}

const VaccinationsBar: React.FC<VaccinationsBarProps> = ({ t, vaccinations, vaccinationType }: VaccinationsBarProps) => {

    return (

        <div className="vaccinations-bar__wrapper">

            <div className="vaccinations-bar__headers__wrapper">
                <div className="vaccinations-bar__headers-name__wrapper">
                    {t('table_header_name')}
                </div>
                <div className="vaccinations-bar__headers-disclaimer__wrapper">
                    {t('table_header_disclaimer')}
                </div>
                <div className="vaccinations-bar__headers-leaflet__wrapper">
                    {t('table_header_leaflet')}
                </div>
            </div>

            <div className="vaccinations-bar__inner-wrapper">

                <div className="vaccinations-bar_single-vaccine__wrapper">
                    {vaccinations.map((vaccine) => (

                        <div key={vaccine.abbreviation} className="vaccinations-bar_single-vaccine">

                            <div className="vaccinations-bar_name__wrapper">
                                {vaccine.fullName}
                            </div>

                            <div className="vaccinations-bar_disclaimer__wrapper">

                                {
                                    vaccine.showDisclaimer && <div className="additional_vertical_space"></div>
                                }

                                {
                                    vaccine.showDisclaimer &&
                                    <div className="vaccinations_bar__header__wrapper_small_screen">
                                        {t('table_header_disclaimer')}:
                                    </div>
                                }

                                {
                                    vaccine.showDisclaimer &&
                                    <div>
                                        {t(`${vaccine.disclaimer}`)}
                                    </div>
                                }
                            </div>

                            <div className="vaccinations-bar_leaflet__wrapper">

                                {
                                    vaccine.leaflet.length > 0 && <div className="additional_vertical_space"></div>
                                }

                                {
                                    vaccine.leaflet.length > 0 &&
                                    <a href={vaccine.leaflet}
                                       target="_blank"
                                       className="vaccinations__link"
                                       rel="noreferrer">
                                        {t('leaflet_link')} <ExternalLink size={12}/>
                                    </a>
                                }
                            </div>

                        </div>
                    ))}
                </div>
            </div>

        </div>

    )

}

export default VaccinationsBar;
